export default __webpack_public_path__ + "static/media/donacion_otros.5ef1b167.png";